import { FormControl } from '@angular/forms';

export interface DrugListFilterFormType {
  drug: FormControl<string | null>;
  includeBrandName: FormControl<string | null>;
  includeGenericName: FormControl<string | null>;
  includeMedicalDevices: FormControl<string | null>;
}

export enum DrugListFilterFormColumnName {
  DrugName = 'DrugName',
  IncludeBrandName = 'IncludeBrandName',
  IncludeGenericName = 'IncludeGenericName',
  IncludeMedicalDevice = 'IncludeMedicalDevice',
};
